import React, { useEffect, useState } from 'react'
//Helpers
import { Col, Container, Row } from 'react-bootstrap'
import useQueryProperty from '@hooks/useQueryProperty'
import { getTags } from '@helpers/helper.properties'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { RealEstateDataPageComponentData } from 'types'
import { ElementHTML } from '@helpers/helper.rendering'

interface ExternalProps {
  propertyID: string
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const detailAmenities = ({
  propertyID,
  developmentID,
  title,
  is_short,
  titlesAmenities,
  global_data,
  alignCenter,
  titleHexa,
  titleElement,
  titleSecondary,
}: CombinedProps) => {
  const tokkoKey = global_data.pageConfig.keys.tokko
  const { data } = propertyID
    ? useQueryProperty(propertyID, tokkoKey)
    : useQueryDevelopment(developmentID, tokkoKey)

  const title_extras = getTitlesArray() || ['Servicios', 'Amenities', 'Generales']

  function getTitlesArray() {
    return [
      titlesAmenities?.titleServices,
      titlesAmenities?.titleEnvironments,
      titlesAmenities?.titleGenerals,
    ]
  }

  const [half, setHalf] = useState(false)

  useEffect(() => {
    var form = document.getElementById('form-detail-float')
    if (form) {
      setHalf(true)
    }
  }, [])

  useEffect(() => {
    if (data) {
      if (data.tags) {
        for (let index = 1; index < 4; index++) {
          if (
            getTags(data).filter(
              (tag) => tag.tag_type === index || tag.type.toString() === index.toString(),
            ).length !== 0
          ) {
            setActive(index)
            break
          }
        }
      }
    }
  }, [data])

  const [active, setActive] = useState(1)

  return (
    <div>
      {getTags(data)?.length > 0 ? (
        data ? (
          <section
            id={title || 'Amenities'}
            className={
              'detailAmenities p-y-config b c ' +
              (getTags(data)?.length === 0 ? ' d-none' : '') +
              (half ? ' half-container-fluid-left' : '')
            }
          >
            <Container fluid>
              <Row className="no-gutters">
                {title && (
                  <Col lg={12}>
                    <ElementHTML
                      children={title}
                      elementType={titleElement || 'h2'}
                      style={{ color: titleHexa || '#1f1f1f' }}
                      className={
                        'section-name mb-lg-5 mb-4' +
                        (alignCenter ? ' text-center' : '') +
                        (titleSecondary ? ' secondary-color' : '')
                      }
                    />
                  </Col>
                )}
                <Col lg={12}>
                  <div className="row align-items-center">
                    <div className="col-lg-2 d-lg-block d-flex">
                      {[1, 2, 3].map((type_id, index) => (
                        <div
                          key={index}
                          className={
                            'cursor-pointer' +
                            (getTags(data).filter(
                              (tag) => tag.tag_type === type_id || tag.type === type_id,
                            ).length > 0
                              ? ''
                              : 'd-none')
                          }
                          onClick={() => setActive(index + 1)}
                        >
                          <ElementHTML
                            children={title_extras[index]!}
                            style={{
                              color: titleHexa || '#1f1f1f',
                              opacity: active == index + 1 ? '100%' : '60%',
                            }}
                            elementType={'h3'}
                            className="mb-5 mt-4 mt-lg-0 text-lg-start section-name"
                          />
                        </div>
                      ))}
                    </div>
                    {[1, 2, 3].map(
                      (type_id, index) =>
                        active == index + 1 && (
                          <div className="col-lg-10">
                            <div className="row no-gutters amenities">
                              {data &&
                                getTags(data)
                                  .filter((tag) => tag.tag_type === type_id || tag.type === type_id)
                                  .map((tag, index) => (
                                    <div
                                      key={index}
                                      style={{ borderRadius: '20px' }}
                                      className="col-lg-4 offset-lg-0 col-6 mb-4 item align-items-center d-flex"
                                    >
                                      <i className="icon-check"></i>
                                      <p>{tag.name}</p>
                                    </div>
                                  ))}
                            </div>
                          </div>
                        ),
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        ) : (
          <div></div>
        )
      ) : (
        <div></div>
      )}
    </div>
  )
}

export default detailAmenities
